import { IAuth, IJwt } from '@/store/models/auth.model'
import { getUserInfo } from '@/services/auth.service'


// 定义一个类型，用于获取 Redux store 中的 state 类型       
export async function isAuth(): Promise<boolean | IJwt> {
    const userInfo = await getUserInfo()
    return userInfo
}

// 校验权限
export const validateAuth = (authInfo: IAuth | null, key:string): boolean => !!authInfo && Reflect.has(authInfo, key)